import { Routes, RouterModule } from '@angular/router';
import { ScheduleTriggerComponent } from './scheduletrigger.component';

const routes: Routes = [
    {
        path: '',
        component: ScheduleTriggerComponent
    },
];

export const ScheduleTriggerRoutes = RouterModule.forChild(routes);
